import React, { useState, useContext, useMemo, useEffect } from "react";
import { Redirect, Link } from "react-router-dom";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import _ from "lodash";
import useApi from "api/useApi";
import styled from "styled-components";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import UploadActionPlans from "./UploadActionPlans";
import FilterData from "./FilterData";
import CustomFilterButton from "components/CustomFilterButton/CustomFilterButton.js";
import SubmitButton from "components/CustomButtons/SubmitButton";
import UserService from "services/UserService";
import { getActionPlansList } from "services/ConfigServices";

const FilterButton = styled.div`
  margin-right: 15px;
  &:hover {
    cursor: pointer;
  }
`;

const UploadButton = styled.div`
  margin-left: 15px;
  &:hover {
    cursor: pointer;
  }
`;

const TableName = styled.h1`
  margin-right: auto;
  margin-left: -8px;
  font-size: 1.3rem;
  font-weight: 500;
`;

export default function usePlandactionsTable() {
  const permis = JSON.parse(localStorage.getItem("permission")) || [];
  const actionplanadmin = permis.includes("actionplan_admin");
  // Though this is a GET, use a POST & method override because the sorted and
  // filtered params are complex (arrays of objects) for easier parsing.
  const appContext = useContext(AdvancedSearchContext);
  const { chartIdGroup } = appContext;
  const [shortName, setShortName] = useState("1");
  const [totalRows, setTotalRows] = useState(0);
  const [anchorEl, setAnchorEl] = useState(null);


  const url = getActionPlansList(chartIdGroup);

  const [gridState, setGridState] = useState();
  const { results, loading, error, refetch, invalidate } = useApi(url, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${UserService.getToken()}`,
    },
  });


  const [filterText, setFilterText] = useState("");
  const [filterId, setFilterId] = useState("Text");
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);

  const SearchComponent = ({ filterText, onFilter, onClear }) => (
    <>
      <div style={{ marginTop: "-7px" }}>
        <TextField
          type="search"
          variant="outlined"
          margin="normal"
          size="small"
          autoFocus="true"
          value={filterText}
          onChange={onFilter}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
        />
      </div>
    </>
  );

  const FilterComponent = ({ onUpload, handleClick, handleClose }) => (
    <>
      <FilterButton type="button" onClick={onUpload}>
        {/*<PublishIcon fontSize="default" />
        <UploadText>Import</UploadText>*/}
        {/* <FilterData /> */}
        <CustomFilterButton onClick={handleClick} />
        <Menu
          id="simple-menu"
          anchorEl={anchorEl}
          keepMounted
          open={Boolean(anchorEl)}
          onClose={handleClose}
        >
          <MenuItem onClick={handleClose}>Profile</MenuItem>
          <MenuItem onClick={handleClose}>My account</MenuItem>
          <MenuItem onClick={handleClose}>Logout</MenuItem>
        </Menu>
      </FilterButton>
    </>
  );

  const UploadComponent = ({ onUpload }) => (
    <>
      {/* <Link
        to={{
          pathname: "/admin/actionplans/selectedplanaction/",
          state: { shortName },
        }}
      >
        <SubmitButton handleSubmit={onUpload}>NOUVEAU PLAN D'ACTION</SubmitButton>
      </Link> */}
      <UploadButton type="button" onClick={onUpload}>
        <UploadActionPlans refetch={refetch} />
      </UploadButton>
    </>
  );

  const filteredItems = _.get(results, `actionplans`, []).filter(
    (item) =>
      (item.parameters.name &&
        item.parameters.name
          .toLowerCase()
          .includes(filterText.toLowerCase())) ||
      (item.parameters.code &&
        item.parameters.code
          .toLowerCase()
          .includes(filterText.toLowerCase())) ||
      (item.parameters.status &&
        item.parameters.status.toLowerCase().includes(filterText.toLowerCase()))
  );

  const dashboard = _.get(results, `dashboard`, []);

  //console.log(filteredItems);

  const subHeaderComponentMemo = useMemo(() => {
    const handleClick = (event) => {
      setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
      setAnchorEl(null);
    };
    const handleClear = () => {
      if (filterText) {
        setResetPaginationToggle(!resetPaginationToggle);
        setFilterText("");
      }
    };

    const onFilterText = (e) => setFilterText(e.target.value);

    return (
      <>
        <TableName>Gestion des plans d&apos;actions</TableName>
        {/* <FilterComponent
          key="FilterComponent"
          //onUpload={handleClick}
          handleClick={handleClick}
          handleClose={handleClose}
        /> */}
        <SearchComponent
          key="SearchComponent"
          onFilter={onFilterText}
          onClear={handleClear}
          filterText={filterText}
        />
        {actionplanadmin && (
          <UploadComponent key="UploadComponent" onUpload={handleClear} />
        )}
      </>
    );
  }, [filterText, resetPaginationToggle]);

  return {
    gridState: {
      defaultPageSize: 10,
      data: filteredItems,
      paginationTotalRows: totalRows,
      filterable: true,
      manual: true,
      paginationResetDefaultPage: resetPaginationToggle,
      subHeaderComponent: subHeaderComponentMemo,
      //onChangeRowsPerPage: handlePerRowsChange,
      //onChangePage: handlePageChange,
      //onSort: handleSort,
      loading,
    },
    dashboard,
    error,
    refetch,
    invalidate,
  };
}
